import React from 'react';
import BooleanRadioButtons from '../components/BooleanRadioButtons';
import Card from '../components/card';
import { InfoCopy, InfoLink } from '../components/info-link';
import { LoanCard } from './card-lenses';

const title = (loan) => {
  switch (loan.get('scenario')) {
    case 'Affordability':
      return 'Are you expecting to buy together with a co-borrower?';
    default:
      return 'Do you want to evaluate options with a co-borrower?';
  }
};

const Info = (props) => (
  <InfoLink title="What is a Borrower?" {...props}>
    <InfoCopy>
      A borrower is any applicant (e.g., individually or jointly) whose credit is used for
      qualifying purposes to determine ability to meet underwriting and eligibility standards.
      &quot;Co-borrower&quot; is a term used to describe any borrower other than the borrower whose
      name appears first on the note.
    </InfoCopy>
  </InfoLink>
);

const Coborrower = ({ model, onChange, ...cardProps }) => (
  <Card title={title(model)} info={Info} {...cardProps}>
    <BooleanRadioButtons
      name="hasCoborrower"
      value={model.get('hasCoborrower')}
      onChange={onChange.bind(null, 'hasCoborrower')}
    />
  </Card>
);

Coborrower.completed = ({ model }) => model.get('hasCoborrower') != null;

Coborrower.id = 'Coborrower';

export default LoanCard(Coborrower);



// WEBPACK FOOTER //
// ./src/cards/coborrower.js